import { onUnmounted, Ref } from '@vue/composition-api';

type RemovedCallback = () => void;

const isVue = (_: Vue|Element): _ is Vue => Boolean((_ as Vue).$el);

export function onRemoved(
	el: Ref<Vue|Element|null>,
	callback: RemovedCallback,
	fallBackTimeout = 1000,
): void {
	if (!window.MutationObserver) {
		onUnmounted(() => {
			setTimeout(callback, fallBackTimeout);
		});
	} else {
		onUnmounted(() => {
			const elVal = el.value;
			// element does not exist
			if (!elVal) {
				callback();
				return;
			}

			const element = isVue(elVal) ? elVal.$el : elVal;

			// element was immediately detached from DOM (no transition)
			if (!document.body.contains(element)) {
				callback();
				return;
			}

			const mutationHandler = (mutations: MutationRecord[], observer: MutationObserver) => {
				for (let i = 0; i < mutations.length; i += 1) {
					const { removedNodes } = mutations[i];

					for (let j = 0; j < removedNodes.length; j += 1) {
						if (removedNodes[j].contains(element)) {
							observer.disconnect();
							callback();
						}
					}
				}
			};

			// start observing parent element for changes to the DOM
			const observer = new MutationObserver(mutationHandler);

			observer.observe(document.body, {
				childList: true,
				subtree: true,
			});
		});
	}
}
